import OrderByProperty from './OrderByProperty';
export default OrderByProperty;